module.exports = __webpack_public_path__ + "static/img/temp.64a08347.jpg";